class SidebarCardService {
    constructor(container) {
        this.$container = $(container)
        this.$cards = this.$container.find('.card-list .card--snippet')
        this.$header = this.$container.find('.aside__header .card__title')
    }

    showCardsForQuestionSlugs(questionSlugs) {
        this.orderCardsByQuestionSlugs(questionSlugs)
        this.$cards.hide()
        let headerUpdated = false
        for (const card of this.$cards) {
            if (questionSlugs.includes(card.dataset['questionSlug'])) {
                const $card = $(card)
                $card.fadeIn("slow")
                if (!headerUpdated) {
                    // update header text with value of the first card
                    // used in mobile view
                    const text = $card.find('.card__title').text()
                    this.setCardsHeaderText(text)
                    headerUpdated = true;
                }
            }
        }
    }

    orderCardsByQuestionSlugs(questionsSlugs) {
        const $parent = this.$cards.parent()
        this.$cards.detach().sort((a, b) => {
            let bIndex = questionsSlugs.indexOf(b.dataset['questionSlug'])
            let aIndex = questionsSlugs.indexOf(a.dataset['questionSlug'])
            // if -1 it's not in the array, means it goes at the end
            aIndex = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex
            bIndex = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex

            return aIndex - bIndex
        })
        $parent.append(this.$cards);
    }

    setCardsHeaderText(text) {
        const $children = this.$header.children()
        this.$header.text(text).append($children)
    }
}

const service = new SidebarCardService($('aside'))

export default service
